/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var GetInternalExamTaskDetails = require('../../services/GetInternalExamTaskDetails');
var GetAllExamLookups = require('../../../common/services/GetAllExamLookups');
var SecRecordExamResultsTaskView = require('./SecRecordExamResultsTaskView');

module.exports = {
  event: 'build:sc:record-exam-results',

  channel: 'task',

  builder: function(task) {
    var defer = $.Deferred();

    var examId = task.taskData.SC.scExamId;
    $.when(GetInternalExamTaskDetails(examId), GetAllExamLookups())
      .done(function(exam, lookups) {
        NProgress.set(0.85);
        defer.resolve(
          new SecRecordExamResultsTaskView({
            model: new Backbone.Model({
              task: task,
              taskId: task.taskId,
              exam: exam,
              examId: examId,
              actions: lookups.examActions,
              decisions: lookups.examDecisions
            })
          })
        );
      })
      .fail(function(err) {
        defer.reject(err);
      });
    return defer.promise();
  }
};
